import styled from 'styled-components';
import Switch from 'react-switch';

export const CustomizerContainer = styled.div`
  padding: 1.45rem;
  width: 100%;
  box-sizing: border-box;
  font-size: 0.8125rem;
`;

export const Section = styled.div`
  margin-bottom: 1.94rem;
`;

export const SectionTitle = styled.h3`
  font-size: 0.8125rem;
  font-weight: 600;
  margin-bottom: 1.45rem;
  color: #1e1e1e;
`;

export const Row = styled.div`
  display: flex;
  gap: 0.97rem;
  margin-bottom: 1.45rem;
  ${props => props.center && 'justify-content: center;'}

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Column = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Label = styled.label`
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #666;
  margin-bottom: 0.73rem;
`;

export const Select = styled.select`
  width: 100%;
  height: 30px;
  padding: 0 1.94rem 0 0.48rem;
  border: 1px solid #ddd;
  border-radius: 7px;
  background: white;
  color: #1e1e1e;
  font-size: 0.8125rem;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.1s ease;
  
  &:focus {
    outline: none;
    border-color: #4AE66E;
  }
`;

export const SelectWrapper = styled.div`
  flex: 1;
  position: relative;

  .select-icon {
    position: absolute;
    right: 0.73rem;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    pointer-events: none;
    transition: transform 0.1s ease;
  }

  &:focus-within .select-icon {
    transform: translateY(-50%) rotate(90deg);
  }
`;

export const TabGroup = styled.div`
  display: flex;
  gap: 0.48rem;
  background: #f5f5f5;
  padding: 0.48rem;
  border-radius: 7px;
  width: 100%;
`;

export const Tab = styled.button`
  flex: 1;
  padding: 0.48rem 0.97rem;
  background: ${props => props.active ? '#1e1e1e' : 'transparent'};
  color: ${props => props.active ? '#fff' : '#1e1e1e'};
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-size: 0.8125rem;
  white-space: nowrap;
  font-weight: 600;
  text-align: center;
`;

export const StyledSwitch = styled(Switch)`
  .react-switch-bg {
    background: ${props => props.checked ? '#4AE66E !important' : '#e0e0e0 !important'};
    border-radius: 12px !important;
    height: 20px !important;
    transition: background-color 0.1s ease !important;
  }
  
  .react-switch-handle {
    background: white !important;
    border: none !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
    height: 16px !important;
    width: 16px !important;
    top: 2px !important;
    transform: none !important;
    transition: all 0.1s ease !important;
    ${props => props.checked ? 'left: 24px !important' : 'left: 4px !important'};
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 30px;
  padding: 0 0.5rem;
  border: 1px solid #ddd;
  border-radius: 7px;
  font-size: 0.8125rem;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #4AE66E;
  }
`;

export const SettingsGroup = styled.div`
  background: #f8f8f8;
  border-radius: 7px;
  padding: 1.45rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.45rem;
`;

export const ControlGroup = styled.div`
  margin-bottom: 1.45rem;
`;

export const ControlLabel = styled.label`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666;
  font-size: 0.8125rem;
  font-weight: 600;
`;

export const Button = styled.button`
    background: #4AE66E;
    color: #fff;
    border: none;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background: #3bc75d;
    }

    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`; 